import React from 'react';
import Button from '../Button/Button';
import { scrollToTop } from '../../utils/scroll';

// CTA de navigation vers l'onglet suivant du suivi (BC/MS, acheteur et prestataire).
//
// POURQUOI ce composant partage :
//  - Un seul CTA orange par onglet. Quand l'onglet propose deja une action qui fait avancer le
//    workflow (lancer, accepter, signer, envoyer...), c'est elle le CTA : la navigation n'a pas
//    lieu d'etre et l'appelant passe `hidden`. La navigation est le REPLI quand aucune action
//    n'est due, pas une action concurrente.
//  - Les 4 modules (SuiviOperationBCV2, SuiviDeCommandeBCV2, SuiviOperationMSV2,
//    SuiviDeCommandeMSV2) partagent la meme regle d'affichage et le meme rendu : la centraliser
//    ici evite que chacun redefinisse son variant et oublie le scroll.
//  - `hidden` est porte par le composant (et non par un `&&` chez l'appelant) pour que la raison
//    du masquage — destination inaccessible, ou action orange deja proposee — reste nommee et
//    lisible sur le site d'appel.
interface NextTabButtonProps {
  label: string;
  onClick: () => void;
  /** Masque le bouton : destination inaccessible, ou une action orange est deja proposee. */
  hidden?: boolean;
  /** Placement dans la barre d'actions de l'appelant. N'affecte pas l'apparence du bouton. */
  className?: string;
}

const NextTabButton: React.FC<NextTabButtonProps> = ({ label, onClick, hidden = false, className }) => {
  if (hidden) return null;

  // Le scroll est fait ici, et pas chez les 4 appelants : ce bouton ne sert QU'A basculer d'onglet,
  // et le contenu d'un onglet est long — sans ca l'utilisateur arrive au milieu du nouvel onglet.
  const handleClick = () => {
    onClick();
    scrollToTop();
  };

  return <Button value={label} variant="primary" className={className} onClick={handleClick} />;
};

export default NextTabButton;
